import { render, staticRenderFns } from "./ComponentWrapper.vue?vue&type=template&id=44d748eb"
import script from "./ComponentWrapper.vue?vue&type=script&lang=ts"
export * from "./ComponentWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports